import React, { useContext, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import parseISO from 'date-fns/parseISO';
import { useIntl } from 'react-intl';
import StepTitle from '../StepTitle';
import StepSection from '../StepSection';
import CurrentStepContext, { CHECKOUT_STEPS } from '../CurrentStepContext';
import UnitInformationForm from './UnitInformationForm';
import Translation from '../../../../../components/stateless/Translation';
import styles from '../styles.scss';
import { sizeMessageProps } from '../constants';

const propTypes = {
  facility: PropTypes.shape(),
  onReviewCost: PropTypes.func.isRequired,
  appliedDiscountPlanId: PropTypes.string,
  continuingExistingLead: PropTypes.bool.isRequired,
  availableUnit: PropTypes.shape().isRequired,
};

const defaultProps = {
  facility: undefined,
  appliedDiscountPlanId: undefined,
};

const UnitInformation = ({
  facility,
  onReviewCost,
  appliedDiscountPlanId,
  continuingExistingLead,
  availableUnit,
}) => {
  const intl = useIntl();
  const stepContext = useContext(CurrentStepContext);
  const scrollToRef = useRef(null);
  const lowestTier = get(stepContext, 'availableUnits[0]');
  const availableUpgrades = stepContext.availableUnits?.filter(availableUnits => (
    availableUnits.tier.rank > 0
  ));

  return (
    <div>
      <StepTitle stepNumber={CHECKOUT_STEPS.UNIT_INFORMATION}>
        {`${CHECKOUT_STEPS.UNIT_INFORMATION}.`}
        {' '}
        <Translation
          id="widgets.checkout.progress.step2"
          defaultMessage="Storage Unit"
        />
      </StepTitle>
      {
        stepContext.currentStep === CHECKOUT_STEPS.UNIT_INFORMATION
        && (
          <StepSection active>
            <UnitInformationForm
              facility={facility}
              onSubmit={stepContext.onStepSubmit}
              currentStep={stepContext.currentStep}
              nextStep={stepContext.isReservation
                ? CHECKOUT_STEPS.COMPLETE
                : CHECKOUT_STEPS.PAYMENT
              }
              maxStep={stepContext.maxStep}
              formError={stepContext.formError}
              submitting={stepContext.submitting}
              formData={stepContext.checkoutData}
              isReservation={stepContext.isReservation}
              scrollToRef={scrollToRef}
              lowestTier={lowestTier}
              availableUpgrades={availableUpgrades}
              onReviewCost={onReviewCost}
              appliedDiscountPlanId={appliedDiscountPlanId}
              continuingExistingLead={continuingExistingLead}
              availableUnits={stepContext.availableUnits}
              availableUnit={availableUnit}
            />
          </StepSection>
        )
      }
      {
        stepContext.currentStep !== CHECKOUT_STEPS.UNIT_INFORMATION
        && stepContext.maxStep > CHECKOUT_STEPS.UNIT_INFORMATION
        && (
          <StepSection showEditStepButton stepNumber={CHECKOUT_STEPS.UNIT_INFORMATION}>
            <Row>
              <Col xs={12}>
                <h5>
                  {`${get(availableUnit, 'width')}'x${get(availableUnit, 'length')}'`}
                  {' '}
                  <Translation
                    {...sizeMessageProps[get(facility, 'unitGroup.categoryName', '').toLowerCase()]}
                  />
                </h5>
                <div>
                  <Translation
                    id="widgets.checkout.checkInDate"
                    defaultMessage="Check-in Date:"
                  />
                  {' '}
                  {intl.formatDate(parseISO(get(stepContext, 'checkoutData.desiredMoveInDate')))}
                </div>
                <div>
                  <Translation
                    id="widgets.checkout.unit"
                    defaultMessage="Unit"
                  />
                  {' '}
                  {`#${get(stepContext, 'checkoutData.unit.name')}`}
                </div>
              </Col>
            </Row>
          </StepSection>
        )
      }
      <div className={styles.scrollTo} ref={scrollToRef} />
    </div>
  );
};

UnitInformation.propTypes = propTypes;
UnitInformation.defaultProps = defaultProps;

export default UnitInformation;
